import { CurrentUserGq } from './CurrentUserGq';

export enum UserTeamRoleGq {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}

export function userTeamRoleGqToNumber(role: UserTeamRoleGq): number {
  if (role === UserTeamRoleGq.OWNER) return 10;
  if (role === UserTeamRoleGq.ADMIN) return 5;
  if (role === UserTeamRoleGq.MEMBER) return 0;
  return 0;
}

export function userCanEditMemberWithRole(
  currentUser: CurrentUserGq,
  memberRole: UserTeamRoleGq
): boolean {
  if (!currentUser.team.accessUserCanEditMembersUpTo) return false;
  return userTeamRoleGqToNumber(currentUser.team.accessUserCanEditMembersUpTo) >= userTeamRoleGqToNumber(memberRole);
}
